export function normalizeCardBin(value?: string | null): string | null {
  const digits = String(value || '').replace(/\D/g, '');
  if (digits.length < 6) {
    return null;
  }
  return digits.slice(0, 8);
}

export function matchesDiscountBin(cardBin: string, discountBins: string[]): boolean {
  const normalized = normalizeCardBin(cardBin);
  if (!normalized || !discountBins?.length) {
    return false;
  }
  return discountBins.some((prefix) => {
    const normalizedPrefix = String(prefix || '').replace(/\D/g, '');
    return normalizedPrefix.length >= 6 && normalized.startsWith(normalizedPrefix);
  });
}
